import HttpData from "@/http/data/http-data";
import AccessControlEventData, {IAccessControlEventData} from "@/http/data/access-control-event-data";

export interface IAccessControlEventPageData {
    current_page: number;
    data: IAccessControlEventData[];
    first_page_url: string;
    from: number | null;
    last_page: number;
    last_page_url: string;
    next_page_url: string | null;
    path: string;
    per_page: number;
    prev_page_url: string | null;
    to: number | null;
    total: number;
}

export default class AccessControlEventPageData extends HttpData {
    public current_page: number;
    public data: AccessControlEventData[];
    public first_page_url: string;
    public from: number | null;
    public last_page: number;
    public last_page_url: string;
    public next_page_url: string | null;
    public path: string;
    public per_page: number;
    public prev_page_url: string | null;
    public to: number | null;
    public total: number;

    constructor(data: IAccessControlEventPageData) {
        super();

        this.current_page = data.current_page;
        this.data = data.data.map(item => new AccessControlEventData(item));
        this.first_page_url = data.first_page_url;
        this.from = data.from ?? null;
        this.last_page = data.last_page;
        this.last_page_url = data.last_page_url;
        this.next_page_url = data.next_page_url ?? null;
        this.path = data.path;
        this.per_page = data.per_page;
        this.prev_page_url = data.prev_page_url ?? null;
        this.to = data.to ?? null;
        this.total = data.total;
    }
}
